import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=57834487&scoped=true&"
import script from "./MainMenu.vue?vue&type=script&lang=ts&"
export * from "./MainMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=57834487&prod&lang=scss&"
import style1 from "./MainMenu.vue?vue&type=style&index=1&id=57834487&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57834487",
  null
  
)

export default component.exports